import { NOTIFICATION } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  notificationList: [],
  readMessages: [],
  unreadMessages: [],
  unreadCount: 0,
  callNotification: false
};

const notificationSlice = createSlice({
  name: NOTIFICATION,
  initialState,
  reducers: {
    notification: (state, { payload }) => {
      state.notificationList = payload.notificationList;
    },
    setNotification: (state, { payload }) => {
      state.readMessages = payload.notifications;
      state.unreadMessages = payload.unRead;
      state.unreadCount = payload.unReadCount;
    },
    resetNotifications: (state) => {
      state.readMessages = [];
      state.unreadMessages = [];
      state.unreadCount = 0;
    },
    setCallNotification: (state, { payload }) => {
      state.callNotification = payload
    },
    reset: () => { },
  },

  // extraReducers: (builder) => {
  //   builder.addCase(loginUser.pending, (state) => {

  //   });
  //   builder.addCase(loginUser.fulfilled, (state, { payload }) => {

  //   });
  //   builder.addCase(loginUser.rejected, (state) => {

  //   });
  // },
});
export const { setNotification, resetNotifications, setCallNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
